import { defineStore } from 'pinia'
import Vue from 'vue'

import type { OpenProps } from '@/plugins/dialog'

type Resolve = (arg: any) => any

// TODO: add types
export const useModal = defineStore('modal', {
  state: () => ({
    custom: {
      component: null as null || Vue,
      show: false,
      resolve: (() => ({})) as Resolve,
      reject: (() => ({})) as Resolve,
      props: {} as OpenProps<any>,
    },
    alert: {
      show: false,
      resolve: (() => ({})) as Resolve,
      reject: (() => ({})) as Resolve,
      props: {} as any,
    },
    prompt: {
      show: false,
      resolve: (() => ({})) as Resolve,
      reject: (() => ({})) as Resolve,
      props: {} as any,
    },
    confirm: {
      show: false,
      resolve: (() => ({})) as Resolve,
      reject: (() => ({})) as Resolve,
      props: {} as any,
    },
  }),
  actions: {
    // custom modal
    SET_MODAL_CONTENT(component: any) {
      this.custom.component = component
    },
    SET_MODAL_PROPS(props: any) {
      this.custom.props = props
    },
    SET_MODAL_RESOLVE(resolve: any) {
      this.custom.resolve = resolve
    },
    SET_MODAL_REJECT(reject: any) {
      this.custom.reject = reject
    },
    SET_MODAL_STATUS(show: any) {
      this.custom.show = show
    },

    // alert
    SET_ALERT_PROPS(props: any) {
      this.alert.props = props
    },
    SET_ALERT_RESOLVE(resolve: any) {
      this.alert.resolve = resolve
    },
    SET_ALERT_REJECT(reject: any) {
      this.alert.reject = reject
    },
    SET_ALERT_STATUS(show: any) {
      this.alert.show = show
    },

    // prompt
    SET_PROMPT_PROPS(props: any) {
      this.prompt.props = props
    },
    SET_PROMPT_RESOLVE(resolve: any) {
      this.prompt.resolve = resolve
    },
    SET_PROMPT_REJECT(reject: any) {
      this.prompt.reject = reject
    },
    SET_PROMPT_STATUS(show: any) {
      this.prompt.show = show
    },

    SET_CONFIRM_PROPS(props: any) {
      this.confirm.props = props
    },
    SET_CONFIRM_RESOLVE(resolve: any) {
      this.confirm.resolve = resolve
    },
    SET_CONFIRM_REJECT(reject: any) {
      this.confirm.reject = reject
    },
    SET_CONFIRM_STATUS(show: boolean) {
      this.confirm.show = show
    },
  },
})
